const PRIMITIVE_INPUT_TYPES = [
  'text',
  'textarea',
  'select',
  'yesNo',
  'date',
  'number',
  'link',
]

export const TOGGLE_MODE_TOGGLE = 'toggle'
export const TOGGLE_MODE_ADD_ONLY = 'addOnly'
export const TOGGLE_MODE_REMOVE_ONLY = 'removeOnly'
export const TOGGLE_MODES = [
  TOGGLE_MODE_TOGGLE,
  TOGGLE_MODE_ADD_ONLY,
  TOGGLE_MODE_REMOVE_ONLY,
]

export const ADDITIONAL_ACTION_LOGIC = 'ADDITIONAL_ACTION_LOGIC'
export const ALLOWED_ACTION_CONDITIONS = 'ALLOWED_ACTION_CONDITIONS'

export const ALL_ACTION_CONDITIONS = [ 'field', 'allOf', 'anyOf' ]

export function isPrimitiveInputType (type) {
  return PRIMITIVE_INPUT_TYPES.includes(type)
}
